import * as Rostering from './rostering';

export enum StudentsControlTab {
  STUDENTS = 'students',
  IMPORT_SETTINGS = 'import-settings',
  IMPORT_LOGS = 'import-logs',
  TERM_MANAGER = 'term-manager',
  INTEGRATIONS = 'integrations',
}

export interface IAdministrationState {
  clever: Rostering.ICleverRosteringState;
}

export * from './rostering';
export * from './import-logs';
